






















































































































import { Component, Vue } from "vue-property-decorator";
import ApplyTrialAccountDialog from "./ApplyTrialAccountDialog.vue";
@Component({
  components: {
    "apply-trial-account-dialog": ApplyTrialAccountDialog,
  },
})
export default class ClientHome extends Vue {
  private loading: boolean = false;

  //弹窗显示
  private dialog: any = {
    applyTrialAccountDialog: false,
  };

  private aggregateData: any = [
    { num: "1800+", title: "服务管理人数量" },
    { num: "6800+", title: "处理的破产案件数" },
    { num: "6000+", title: "召开会议" },
    { num: "180万+", title: "涉及债权人数量" },
    { num: "60万+", title: "申报债权数量" },
    { num: "3092亿", title: "涉及总金额" },
  ];

  created() {
    // this.onLoad();
  }
  public onLoad() {}

  private scrollToSection(sectionId: any) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }
}
